<div class="pill" [ngClass]="theme">
    <span [ngClass]="contentClass">
        {{text}}
        <ng-content></ng-content>
    </span>
</div>
